import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import {namespace} from "vuex-class";
import {DOCUMENT_GET_DOC_BY_ID, DOCUMENT_MODULE_NAMESPACE} from "../../../store/document";

const DocumentStore = namespace(DOCUMENT_MODULE_NAMESPACE)

@Component
class DocumentDetail extends Vue {
  dtIsLoading: boolean
  dtCurrentDocument: any

  constructor () {
    super()
    this.dtIsLoading = false
    this.dtCurrentDocument = null
  }

  @DocumentStore.Action(DOCUMENT_GET_DOC_BY_ID)
  storeGetDocById: ({id: string}) => Promise<any>

  created () {
    this.loadData()
  }

  mounted () {

  }

  loadData () {
    console.log('this.$route.params', this.$route.params)
    this.storeGetDocById({id: this.$route.params.cid})
      .then(response => {
        console.log('Response => ', response)
        this.dtCurrentDocument = response
      })
  }
}

export default DocumentDetail



// WEBPACK FOOTER //
// ./src/containers/documents/document-detail/index.ts